import ReactDOM from 'react-dom/client'
import './index.css'
import App from './App'
import {Provider} from "react-redux"
import React from 'react'
import {AxiosInterceptor} from "./api"
import store from "./common/store"

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
)
root.render(
    <Provider store={store}>
        <AxiosInterceptor>
            <App/>
        </AxiosInterceptor>
    </Provider>
)

